import { domReady, initRegularFormSubmissionActivity, initBlockEnterKeyForDisabledButton } from 'utilities/dom';

domReady(() => {

	const btnSubmit = document.getElementById('getCouponsBtn');
	const errorMsg = document.querySelector('.errorMsg');
	window.initFormValidation(true, 'form.scForm');

	function noCouponSelected () {

		return document.querySelector('.scCouponCheckbox:checked') === null;

	}

	function toggleErrorsOnBoxes (add) {

		if (add || add === undefined) {

			$('.scBox').addClass('error');
			$('.scBoxContainer')
				.children('.validationContainer')
				.each((i, coupon) => {

					$(coupon).fadeIn();

				});

		} else {

			$('.scBox').removeClass('error');
			$('.scBoxContainer')
				.children('.validationContainer')
				.each((i, coupon) => {

					$(coupon).hide();

				});

		}

	}

	$('.scCouponCheckbox').on('click', function (e) {

		e.stopPropagation();
		if (this.checked && $('.scBox').hasClass('error')) {

			toggleErrorsOnBoxes(false);

		}

	});

	// this should be run first before initRegularFormSubmissionActivity in order for this to stop immediate propagation
	btnSubmit.addEventListener(
		'click',
		function (e) {

			const isFormValid = $(this.form).valid();

			if (noCouponSelected()) {

				e.preventDefault();
				e.stopImmediatePropagation();
				toggleErrorsOnBoxes();

				return false;

			}

			if (errorMsg) {

				if (isFormValid) {

					errorMsg.classList.add('hidden');

				} else {

					errorMsg.classList.remove('hidden');
					errorMsg.focus();

				}

			}

			return isFormValid;

		},
		true
	);

	$('.scForm input').on('keydown', (e) => {

		if (e.which === 13) {

			toggleErrorsOnBoxes(noCouponSelected());

		}

	});

	$('.scBox').on('click', function (e) {

		if (e.target.tagName.toLowerCase() === 'label') {

			return;

		}

		$('.scCouponCheckbox', this).click();

	});

	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

	}

	initRegularFormSubmissionActivity(btnSubmit);
	initBlockEnterKeyForDisabledButton(btnSubmit);

});
